module.exports = __webpack_public_path__ + "static/main-500-6e25bdab9913b9106023e4fbdabbf964.png";